import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedData } from 'src/app/shared/contexts/asyncData';

import { StarterDashboardV2CommentsPaginatedData } from './commentsPaginatedData.graphql';
import type {
	StarterDashboardV2CommentsPaginatedDataQuery,
	StarterDashboardV2CommentsPaginatedDataQueryVariables,
} from './commentsPaginatedData.graphql';

export type Comment = NonNullable<
	NonNullable<StarterDashboardV2CommentsPaginatedDataQuery['petition']>['commentsConnection']['nodes'][0]
>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	petitionSlug: string,
	cursor?: string,
): Promise<PaginatedData<Comment>> {
	const { data } = await fetch<
		StarterDashboardV2CommentsPaginatedDataQuery,
		StarterDashboardV2CommentsPaginatedDataQueryVariables
	>({
		query: StarterDashboardV2CommentsPaginatedData,
		variables: { cursor: cursor ?? null, petitionSlugOrId: petitionSlug },
		rejectOnError: true,
	});

	if (!data.petition) throw new NotFoundError();

	return {
		items: data.petition.commentsConnection.nodes,
		cursor: data.petition.commentsConnection.pageInfo.endCursor,
		hasNextPage: data.petition.commentsConnection.pageInfo.hasNextPage,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
